import React, { useEffect } from 'react';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, IconButton, Stack, Typography, useTheme } from '@mui/material';
import { AddCircle, Delete } from '@mui/icons-material';
import { useQuery, useQueryClient } from 'react-query';
import { useAuthContext } from '../../../context/AuthContext';
import QueryKey from '../../../utils/QueryKey';
import { editPotServ, getSinglePotServ } from '../../../services/po-service';
import { checkNumFormat, datePickerformat, isNotEmpty } from '../../../utils/format';
import { customAlert, notify } from '../../../components/notify';
import route from '../../../utils/Routes';
import BgBoxOld from '../../../components/BgBoxOld';
import CtrlLabelTxtFieldInfo from '../../../components/CtrlLabelTxtFieldInfo';
import ScrollBox from '../../../components/ScrollBox';
import CtrlCustomDropDown from '../../../components/CtrlCustomDropDown';
import AttachFileUpload from "../../../components/AttachFileUpload";

const prodStatusArr = [
    { value: "awaiting_post_po_clarify", label: "AWAITING POST-PO CLARIFICATION" },
    { value: "packing_in_prog", label: "PACKING IN PROGRESS" },
    { value: "material_ready", label: "MATERIAL IS READY" },
    { value: "awaiting_sdo_dhl_pickup", label: "AWAITING SDO/DHL PICK-UP" },
    { value: "back_order", label: "BACK ORDER" },
    { value: "partially_del", label: "PARTIALLY DELIVERED" },
    { value: "del_completed", label: "DELIVERY COMPLETED" }];

const paidArr = [
    { value: "1", label: "YES" },
    { value: "0", label: "NO" }];


function EditPotPage() {
    const theme = useTheme();
    const location = useLocation();
    const queryClient = useQueryClient();
    const { setLoadingScreen, setNavComValue } = useAuthContext();
    const { poId, comId, pgNo, s, st } = location.state;
    const navigate = useNavigate();
    const txtFieldProps = { fontSize: 12, height: 35, borderRadius: 1.7, marginTop: 0.1 };
    const [formErrors, setFormErrors] = useState({});
    const [poVal, setPoVal] = useState({ poReqNo: "", delLocation: "" })
    const [products, setProducts] = useState([
        {
            id: "",
            lineNo: "",
            comProdIdStrg: "",
            mfrName: "",
            prodName: "",
            orderedQty: "",
            poDeliveredQty: "",
            balQty: "",
            prodStatus: "",
            expecDelDate: "",
            estTimeArr: "",
            isPaid: "",
            amtcRemarks: "",
            clientRemarks: "",
            doDataArr: [
            ],
        },
    ]);
    const { isLoading, isError, error, data: poData } = useQuery([QueryKey.potInfo, poId], () => getSinglePotServ(poId),
        {
            enabled: isNotEmpty(poId),
            refetchOnMount: false,
            refetchOnWindowFocus: false,
        })

    useEffect(() => {
        if (!comId) {
            notify("error", "Company not found!---");
            navigate("/", { replace: true })
        }
        if (!poId) {
            notify("error", "Company not found!----");
            navigate("/", { replace: true })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comId, poId]);

    useEffect(() => {
        setNavComValue({ comId })
        return () => setNavComValue({ comId: "" }); // Reset when leaving the page
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, comId]);

    useEffect(() => {
        if (isLoading) {
            setLoadingScreen(true);
        } else {
            setLoadingScreen(false);
        }
    }, [isLoading, setLoadingScreen]);

    useEffect(() => {
        if (!poData)
            return;
        setProducts(formatApiResData(poData));

        setPoVal({ poReqNo: poData?.poIdStrg, delLocation: poData?.delLocation })
    }, [poData]);

    function formatApiResData(data) {
        let tempProdArr = [];
        const prodArr = data?.poProdArr;
        for (const prod of prodArr) {
            const prodObj = {
                id: prod?.id,
                lineNo: prod?.lineNo,
                comProdIdStrg: prod?.comProdIdStrg,
                mfrName: prod?.mfrName,
                prodName: prod?.prodName,
                orderedQty: prod?.orderedQty,
                poDeliveredQty: prod?.poDeliveredQty,
                balQty: prod?.balQty,
                prodStatus: prod?.prodStatus,
                expecDelDate: datePickerformat(prod?.expecDelDate),
                estTimeArr: datePickerformat(prod?.estTimeArr),
                isPaid: prod?.isPaid,
                amtcRemarks: prod?.amtcRemarks,
                clientRemarks: prod?.clientRemarks,
                doDataArr: prod?.doProdArr ? prod?.doProdArr.map((i) => {
                    return {
                        id: i.id,
                        doLineNo: i.doLineNo,
                        doIdStrg: i.doIdStrg,
                        deliveredQty: i.deliveredQty,
                        deliveredAt: datePickerformat(i?.deliveredAt),
                        files: i.files ? JSON.parse(i.files) : []
                    }
                }) : []
            };
            tempProdArr.push({ ...prodObj });
        }

        console.log(tempProdArr)
        return tempProdArr;
    }

    async function handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(e.target);
        const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
        let errorsObj = validate(inputObject);
        setFormErrors(errorsObj);
        if (Object.keys(errorsObj).length > 0)
            return;

        setLoadingScreen(true);
        try {
            const payload = {
                poReqNo: poVal.poReqNo, delLocation: poVal.delLocation,
                poProdArr: products.map((product) => ({
                    ...product,
                    lineNo: checkNumFormat(product.lineNo),
                    orderedQty: checkNumFormat(product.orderedQty),
                    poDeliveredQty: checkNumFormat(product.poDeliveredQty),
                    balQty: checkNumFormat(product.balQty),
                    isPaid: checkNumFormat(product.isPaid),
                    doDataArr: product.doDataArr.map((doItem) => ({
                        ...doItem,
                        doLineNo: checkNumFormat(doItem.doLineNo),
                        deliveredQty: checkNumFormat(doItem.deliveredQty),
                    })),
                })),

            }

            console.dir(payload);
            const { message } = await editPotServ(payload, poId);
            notify("success", message);
            queryClient.invalidateQueries();
            navigate(`${route.aPoTracking}/?comId=${comId}&pgNo=${pgNo}&st=${st}&s=${encodeURIComponent(s)}`, { replace: true })
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    };

    async function handleCancel() {
        navigate(`${route.aPoTracking}/?comId=${comId}&pgNo=${pgNo}&st=${st}&s=${encodeURIComponent(s)}`, { replace: true })
    }

    function validate(values) {
        const errors = {};

        if (!values.poReqNo)
            errors.poReqNo = "PO NUMBER is required!";

        return errors;
    };



    const addProduct = () => {
        setProducts([
            ...products,
            {
                id: "",
                lineNo: "",
                comProdIdStrg: "",
                mfrName: "",
                prodName: "",
                orderedQty: "",
                poDeliveredQty: "",
                balQty: "",
                prodStatus: "",
                expecDelDate: "",
                estTimeArr: "",
                isPaid: "",
                amtcRemarks: "",
                doDataArr: [

                ],
            },
        ]);
    };

    const addDeliveryOrder = (prodIndex) => {
        const updatedProducts = [...products];
        updatedProducts[prodIndex].doDataArr.push({
            id: "",
            doLineNo: "",
            doIdStrg: "",
            deliveredQty: "",
            deliveredAt: "",
            files: []
        });
        setProducts(updatedProducts);
    };

    const removeProduct = (index) => {
        const updatedProducts = [...products];
        updatedProducts.splice(index, 1);
        setProducts(updatedProducts);
    };

    const removeDeliveryOrder = (prodIndex, doIndex) => {
        const updatedProducts = [...products];
        updatedProducts[prodIndex].doDataArr.splice(doIndex, 1);
        setProducts(updatedProducts);
    };

    const handleProdValChange = (index, e) => {
        const { name: field, value } = e.target;
        const updatedProducts = [...products];
        updatedProducts[index][field] = value
        setProducts(updatedProducts);
    };


    const handleDoValChange = (prodIndex, doIndex, e) => {
        const { name: field, value } = e.target;
        const updatedProducts = [...products];
        updatedProducts[prodIndex].doDataArr[doIndex][field] = value
        setProducts(updatedProducts);
    };

    const handleValChange = (e) => {
        const { name, value } = e.target;
        setPoVal(prevSel => { return { ...prevSel, [name]: value } })
    };

    useEffect(() => {
        console.dir(products)
    }, [products])


    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    function handleOnFileUpload(prodIndex, doIndex, uploadedFiles) {
        const updatedProducts = [...products];
        const existingFiles = updatedProducts[prodIndex].doDataArr[doIndex]['files']
        updatedProducts[prodIndex].doDataArr[doIndex]['files'] = [...existingFiles, ...uploadedFiles]
        setProducts(updatedProducts);
    }

    function handleFileRemove(prodIndex, doIndex, fileIndex) {
        const updatedProducts = [...products];
        const existingFiles = updatedProducts[prodIndex].doDataArr[doIndex]['files']
        existingFiles.splice(fileIndex, 1);
        updatedProducts[prodIndex].doDataArr[doIndex]['files'] = existingFiles;
        setProducts(updatedProducts);
    }

    return (
        <Stack height={"100%"} width={"100%"}>
            <form onSubmit={handleSubmit} noValidate id='addPo' style={{ padding: 0, height: "100%" }}>
                <Stack direction={'row'} justifyContent='space-between' alignItems='center' my={1} pl={5} pr={10}>
                    <Typography sx={{ fontSize: 18, fontWeight: "bold" }}>EDIT ORDER REQUEST</Typography>
                    <Stack direction={'row'} alignItems='center' gap={1} >
                        <Button variant="text" sx={{ height: 30, width: 120, color: theme.palette.custom.btn }} onClick={handleCancel}>{"Cancel"}</Button>
                        <Button variant="contained" type='submit' sx={{ height: 30, width: 120, color: "white", backgroundColor: theme.palette.custom.btn }}>
                            {"SAVE PO"}</Button>
                    </Stack>
                </Stack>
                <BgBoxOld height={"93%"} py={1} px={1}>
                    <Stack direction={"row"} px={2} >
                        <CtrlLabelTxtFieldInfo name="poReqNo" title={"PO NUMBER *"} errMsg={formErrors.poReqNo} {...txtFieldProps}
                            value={poVal?.poReqNo} onChange={handleValChange} />
                        <Box width={100} />
                        <CtrlLabelTxtFieldInfo name="delLocation" title={"DELIVERY LOCATION"} {...txtFieldProps}
                            value={poVal?.delLocation} onChange={handleValChange} />
                    </Stack>

                    <Stack direction={'row'} alignItems='center'  >
                        <Typography sx={{ fontSize: 15, fontWeight: "bold" }}>ADD PRODUCT</Typography>
                        <IconButton onClick={addProduct}>
                            <AddCircle sx={{ color: theme.palette.custom.btn }} />
                        </IconButton>
                    </Stack>
                    <ScrollBox height={"82%"} >
                        {products.map((prod, pi) => (
                            <Box key={pi} sx={{
                                px: 2, py: 2, backgroundColor: "#ffff", borderRadius: 1.4, border: 1, position: "relative", mb: 1, height: 400,
                                borderColor: '#E3E3E3', width: "100%", display: "flex", flexDirection: "row", alignItems: "start", justifyContent: "center"
                            }}>
                                <Stack justifyContent={"center"} alignItems={"center"} width={"55%"} pl={2} gap={1}>
                                    <Stack direction={"row"} gap={2} alignItems={"center"}>
                                        <CtrlLabelTxtFieldInfo name="lineNo" title={"POL"}  {...txtFieldProps} width={100}
                                            type="number" step={1} value={prod.lineNo} onChange={(e) => handleProdValChange(pi, e)} />
                                        <CtrlLabelTxtFieldInfo name="comProdIdStrg" title={"MATERIAL CODE"} {...txtFieldProps} width={250}
                                            value={prod.comProdIdStrg} onChange={(e) => handleProdValChange(pi, e)} />
                                        <CtrlLabelTxtFieldInfo name="prodName" title={"DESCRIPTION"}  {...txtFieldProps} width={250}
                                            value={prod.prodName} onChange={(e) => handleProdValChange(pi, e)} />
                                    </Stack>
                                    <Stack direction={"row"} gap={4}>
                                        <CtrlLabelTxtFieldInfo name="mfrName" title={"ORIGINAL MNFR"} {...txtFieldProps} width={300}
                                            value={prod.mfrName} onChange={(e) => handleProdValChange(pi, e)} />
                                        <CtrlCustomDropDown title={"STATUS"} name={"prodStatus"} ddArr={prodStatusArr}
                                            {...txtFieldProps} width={300} value={prod.prodStatus} handleDDChange={(e) => handleProdValChange(pi, e)} />
                                    </Stack>
                                    <Stack direction={"row"} gap={2}>
                                        <CtrlLabelTxtFieldInfo name="orderedQty" title={"PO QTY	"}  {...txtFieldProps} width={200} type="number"
                                            step={1} value={prod.orderedQty} onChange={(e) => handleProdValChange(pi, e)} />
                                        <CtrlLabelTxtFieldInfo name="poDeliveredQty" title={"DELIVERED QTY"} {...txtFieldProps} width={200} type="number"
                                            step={1} value={prod.poDeliveredQty} onChange={(e) => handleProdValChange(pi, e)} />
                                        <CtrlLabelTxtFieldInfo name="balQty" title={"REMAINING QTY"} {...txtFieldProps} width={200} type="number"
                                            step={1} value={prod.balQty} onChange={(e) => handleProdValChange(pi, e)} />
                                    </Stack>
                                    <Stack direction={"row"} gap={2}>
                                        <CtrlLabelTxtFieldInfo name="estTimeArr" type={"date"} title={"ETA"}  {...txtFieldProps} width={200}
                                            value={prod.estTimeArr} onChange={(e) => handleProdValChange(pi, e)} />
                                        <CtrlLabelTxtFieldInfo name="expecDelDate" type={"date"} title={"ETD"} {...txtFieldProps}
                                            width={200} value={prod.expecDelDate} onChange={(e) => handleProdValChange(pi, e)} />
                                        <CtrlCustomDropDown title={"PAYMENT STATUS"} name={"isPaid"} ddArr={paidArr} {...txtFieldProps}
                                            width={200} value={prod.isPaid} handleDDChange={(e) => handleProdValChange(pi, e)} />
                                    </Stack>
                                    <Stack direction={"row"}>
                                        <CtrlLabelTxtFieldInfo name="amtcRemarks" title={"AMTC REMARKS"} {...txtFieldProps} width={635} multiline={true}
                                            height={70} rows={3} value={prod.amtcRemarks} onChange={(e) => handleProdValChange(pi, e)} />
                                    </Stack>

                                    <IconButton
                                        sx={{ position: "absolute", top: -3, left: -8 }} aria-label="delete"
                                        onClick={() => removeProduct(pi)}>
                                        <Delete color='error' />
                                    </IconButton>
                                </Stack>
                                <Box width={2} bgcolor={'#E3E3E3'} height={"100%"} mx={2} />

                                <Stack justifyContent={"start"} height={"100%"} width={"45%"}>
                                    <Stack direction={'row'} alignItems='center'>
                                        <Typography sx={{ fontSize: 15, fontWeight: "bold" }}>ADD DELIVERY ORDER</Typography>
                                        <IconButton onClick={() => addDeliveryOrder(pi)}>
                                            <AddCircle sx={{ color: theme.palette.custom.btn }} />
                                        </IconButton>
                                    </Stack>
                                    <ScrollBox height={"95%"} width={"100%"}>{
                                        prod.doDataArr.map((doItem, di) => (
                                            <Stack key={`${pi}_${di}`} sx={{
                                                px: 2, py: 2, borderRadius: 1.4, gap: 2, mb: 2,
                                                backgroundColor: "rgba(162, 214, 249, 0.2)", width: "100%", position: "relative"
                                            }}>
                                                <Stack direction={"row"} gap={2} alignItems={"center"}>
                                                    <CtrlLabelTxtFieldInfo name="doLineNo" title={"DOL"}  {...txtFieldProps} width={200} type="number"
                                                        step={1} value={doItem.doLineNo} onChange={(e) => handleDoValChange(pi, di, e)} />
                                                    <CtrlLabelTxtFieldInfo name="doIdStrg" title={"DO NUMBER"} {...txtFieldProps} width={300}
                                                        value={doItem.doIdStrg} onChange={(e) => handleDoValChange(pi, di, e)}
                                                    />
                                                </Stack>
                                                <Stack direction={"row"} gap={2} alignItems={"center"}>
                                                    <CtrlLabelTxtFieldInfo name="deliveredQty" title={"QTY"}  {...txtFieldProps} width={200} type="number"
                                                        step={1} value={doItem.deliveredQty} onChange={(e) => handleDoValChange(pi, di, e)} />
                                                    <CtrlLabelTxtFieldInfo name="deliveredAt" type={"date"} title={"DELIVERED ON"} {...txtFieldProps}
                                                        width={300} value={doItem.deliveredAt} onChange={(e) => handleDoValChange(pi, di, e)} />
                                                </Stack>
                                                {doItem.files && (
                                                <AttachFileUpload 
                                                    inputId={`file-upload-${pi}-${di}`}
                                                    btnHeight={35} btnIcSize={25} maxHeight={200} width={"100%"} filesArr={doItem.files}
                                                    fileWidth={163} needFileIc={false}
                                                    onUpload={(files) => handleOnFileUpload(pi, di, files)}
                                                    onRemove={(fileIndex) => handleFileRemove(pi, di, fileIndex)} />
                                                )}
                                                {/* <Stack direction={"row"} gap={2}>
                                                    <CtrlLabelTxtFieldInfo name="invNo" title={"INVOICE NO"}  {...txtFieldProps} width={200}
                                                        value={doItem.invNo} onChange={(e) => handleDoValChange(pi, di, e)} />
                                                    <CtrlLabelTxtFieldInfo name="invDate" title={"INVOICE DATE"} {...txtFieldProps} width={200}
                                                        type="date" step={1} value={doItem.invDate} onChange={(e) => handleDoValChange(pi, di, e)} />
                                                    <CtrlLabelTxtFieldInfo name="invStatus" title={"INVOICE STATUS"} {...txtFieldProps} width={200}
                                                        step={1} value={doItem.invStatus} onChange={(e) => handleDoValChange(pi, di, e)} />
                                                </Stack> */}
                                                <IconButton
                                                    sx={{ position: "absolute", top: -3, right: -8 }} aria-label="delete"
                                                    onClick={() => removeDeliveryOrder(pi, di)}>
                                                    <Delete color='error' />
                                                </IconButton>
                                            </Stack>))}
                                    </ScrollBox>
                                </Stack>
                            </Box>
                        ))}
                    </ScrollBox>
                </BgBoxOld>
            </form>
        </Stack>
    )
}

export default EditPotPage